import { useState, useEffect } from "react";
import headlinesSSEClient from "./headlinesSSEClient";

/**
 * Returns whether the headlines SSE client has fallen back to HTTP polling mode.
 * This happens when SSE connections repeatedly fail (e.g. corporate firewall).
 */
export function useIsPollingMode(): boolean {
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => {
    const sub = headlinesSSEClient.onPollingModeChange(setIsPolling);
    return () => sub.unsubscribe();
  }, []);

  return isPolling;
}
